import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = new BehaviorSubject<string>('ar');
  currentLang$ = this.currentLang.asObservable();
  
  private isLoading = new BehaviorSubject<boolean>(true);
  isLoading$ = this.isLoading.asObservable();

  constructor(private translate: TranslateService) {
    const lang = localStorage.getItem('lang') || 'ar'; 
    this.currentLang.next(lang);
    this.translate.setDefaultLang('ar');
    this.translate.use(lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    if (lang === 'ar') {
      document.body.classList.add('arabic');
    } else {
      document.body.classList.remove('arabic');
    }
    
    // Track when translations are loaded using onLangChange
    this.translate.onLangChange.subscribe(() => {
      this.isLoading.next(false);
    });
    
    // Also check if translations are already loaded
    this.translate.get('signin').subscribe(() => {
      this.isLoading.next(false);
    });
  }

  setLanguage(lang: string) {
    if (this.currentLang.value !== lang) {
      this.isLoading.next(true);
      this.currentLang.next(lang);
      this.translate.use(lang).subscribe(() => {
        this.isLoading.next(false);
      }); 
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = lang;
      localStorage.setItem('lang', lang); 
    }
    if (lang === 'ar') {
      document.body.classList.add('arabic');
    } else {
      document.body.classList.remove('arabic');
    }
  }

  getCurrentLanguage(): string {
    return this.currentLang.value;
  }

  getIsLoading(): boolean {
    return this.isLoading.value;
  }
}